module.exports = __webpack_public_path__ + "static/langojango-luganda-language-phrasebook-0267aa1fbe9dcf8ebdc66a0640684b4a.png";